import { computePlates, formatPlates } from "@/lib/plates";

export default function PlateBreakdown({ targetWeight, barWeight, equipmentName }) {
    if (!barWeight || barWeight <= 0) {
        return (
            <div className="text-[11px] tracking-[0.2em] uppercase text-zinc-300" data-testid="plate-breakdown">
                {equipmentName || "—"}
            </div>
        );
    }
    const plates = computePlates(targetWeight, barWeight);
    if (plates === null) return null;
    return (
        <div className="text-center" data-testid="plate-breakdown">
            <div className="text-[10px] tracking-[0.25em] uppercase text-zinc-300">
                {equipmentName} ({barWeight} lb)
            </div>
            <div className="text-sm text-zinc-200 mt-1">
                Each side: <span className="text-brand-red font-semibold">{formatPlates(plates)}</span>
            </div>
        </div>
    );
}
